import { render, staticRenderFns } from "./editCalendarEvent.vue?vue&type=template&id=3b6b8d52&scoped=true&"
import script from "./editCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./editCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./editCalendarEvent.vue?vue&type=style&index=0&id=3b6b8d52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b8d52",
  null
  
)

export default component.exports